var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6882 15.0223L31.9992 0.333344L17.3102 15.0223L31.9992 29.7113L46.6882 15.0223ZM29.3779 32.3335L14.6889 17.6445L-6.10352e-05 32.3335L14.6889 47.0225L29.3779 32.3335ZM49.3111 17.6445L64.0001 32.3335L49.3111 47.0225L34.6221 32.3335L49.3111 17.6445ZM32.0248 60.9224C38.2393 60.9224 43.2771 55.8846 43.2771 49.6701C43.2771 43.4557 38.2393 38.4179 32.0248 38.4179C25.8104 38.4179 20.7726 43.4557 20.7726 49.6701C20.7726 55.8846 25.8104 60.9224 32.0248 60.9224Z",
    fill: "#00A9E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtLogo);
export default __webpack_public_path__ + "static/media/nt-logo.0985bf27053cc5859cf1ec9c24f91f80.svg";
export { ForwardRef as ReactComponent };